import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 1rem 2rem;
  background: rgba(18, 18, 18, 0.95);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const Logo = styled.img`
  height: 32px;
  @media (max-width: 768px) {
    height: 28px;
  }
`;

const NavLinks = styled.div<{ isOpen: boolean }>`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    gap: 0;
    background: rgba(18, 18, 18, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 1rem 0;
  }
`;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;

  @media (min-width: 769px) {
    &:hover > div {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const DropdownContent = styled.div<{ isOpen?: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  background: rgba(18, 18, 18, 0.95);
  backdrop-filter: blur(10px);
  min-width: 220px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 1000;
  margin-top: 0.5rem;
  border: 1px solid rgba(255,255,255,0.1);

  @media (max-width: 768px) {
    position: static;
    box-shadow: none;
    border-radius: 0;
    border: none;
    margin: 0;
    width: 100%;
    opacity: ${props => props.isOpen ? 1 : 0};
    visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
    transform: none;
    height: ${props => props.isOpen ? 'auto' : '0'};
    overflow: hidden;
  }
`;

const NavLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  
  &:hover {
    color: #ff6b00;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    width: 100%;
    justify-content: space-between;
  }
`;

const DropdownLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.75rem 1rem;
  display: block;
  text-transform: none;
  font-size: 0.9rem;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: rgba(255,107,0,0.1);
  }
`;

const BuyNowButton = styled(Link)`
  background: #ff6b00;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  &:hover {
    background: #ff8533;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    margin: 1rem;
    padding: 0.75rem;
  }
`;

const MenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  return (
    <Nav>
      <Link to="/"><Logo src="/assets/rsr-logo.png" alt="RSR Logo" /></Link>
      <MenuButton onClick={toggleMenu}>{isMenuOpen ? '✕' : '☰'}</MenuButton>
      <NavLinks isOpen={isMenuOpen}>
        <DropdownContainer>
          <NavLink to="/" onClick={(e) => {
            e.preventDefault();
            toggleDropdown();
          }}>
            PRODUCTS
            <span>{isDropdownOpen ? '▴' : '▾'}</span>
          </NavLink>
          <DropdownContent isOpen={isDropdownOpen}>
            <DropdownLink to="/directtorque" onClick={() => {
              setIsMenuOpen(false);
              setIsDropdownOpen(false);
            }}>DirectTorque X20</DropdownLink>
            <DropdownLink to="/motionpro" onClick={() => {
              setIsMenuOpen(false);
              setIsDropdownOpen(false);
            }}>MotionPro 3DOFL4150</DropdownLink>
          </DropdownContent>
        </DropdownContainer>
        <NavLink to="/about" onClick={() => setIsMenuOpen(false)}>About</NavLink>
        <BuyNowButton to="https://wa.me/6281916010121" onClick={() => setIsMenuOpen(false)}>
          Contact Us
          <span>↗</span>
        </BuyNowButton>
      </NavLinks>
    </Nav>
  );
};

export default Navbar;
